import { render, staticRenderFns } from "./Imagens.vue?vue&type=template&id=0976654d&"
import script from "./Imagens.vue?vue&type=script&lang=ts&"
export * from "./Imagens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Imagens.vue"
export default component.exports